<template>
  <div>
    <div id="map"></div>
    <Rehearsal />

    <WaterQualityDetail
      :visible="visible"
      :detail="detail"
      :params="params"
      @cancel="
      visible = false;
    detail = {};
    params = {};
                                                                                                                  "
    />
  </div>
</template>
<script>
import { mapMutations, mapState } from "vuex";

import marker1 from "@/assets/marker1.png";
import marker2 from "@/assets/marker2.png";
import marker3 from "@/assets/marker3.png";
import marker4 from "@/assets/marker4.png";
import marker5 from "@/assets/marker5.png";
import marker6 from "@/assets/marker6.png";

import markerWater from "@/assets/marker-water.png";
import markerWarning from "@/assets/marker-warning.png";

// import markerImage from "@/assets/marker.png";

import markerWaterGateActive from "@/assets/gate-active.png";

import Rehearsal from "./index.vue";
import { Scene, PointLayer, LineLayer, HeatmapLayer } from "@antv/l7";
// LayerPopup
import { GaodeMapV2 } from "@antv/l7-maps";

import sewagePipe from "./mixins/sewage-pipe";
import rainPipe from "./mixins/rain-pipe";

import WaterQualityDetail from "./components/water-quality-detail.vue";

import ventData from "./vent";

// import { getAngle } from "@/utils/map";

function getAngle(lng1, lat1, lng2, lat2) {
  let angle =
    (Math.atan2(Math.abs(lat1 - lat2), Math.abs(lng1 - lng2)) * 180) / Math.PI;

  if (lng2 < lng1 && lat2 < lat1) {
    // 终点比起点的经度小，纬度小
    // 第三象限
    angle = angle + 180;
    // 逆时针旋转，并多转90度
    angle = -angle - 90;
  }

  if (lng2 > lng1 && lat2 < lat1) {
    // 终点比起点的经度大，纬度小
    // 第四象限
    // 顺时针旋转，
    angle = angle - 90;
  }

  if (lng2 < lng1 && lat2 > lat1) {
    // 终点经度更小，纬度更大
    // 第2象限
    // angle = -(angle + 90 + 90);
    angle = -(180 - angle + 90);
  }

  if (lng2 > lng1 && lat2 > lat1) {
    // 终点的经度更大，纬度也更大
    // 第1象限
    angle = -(angle + 90);
  }

  return angle;
}

import markerBlue from "@/assets/model/marker-blue.png";
// import markerRed from "@/assets/model/marker-red.png";

export default {
  mixins: [sewagePipe, rainPipe],
  components: {
    Rehearsal,
    WaterQualityDetail,
  },

  data() {
    return {
      visible: false,
      detail: {},
      params: {},
    };
  },

  computed: {
    ...mapState("map", [
      "clearMap",
      "rainList",
      "waterList",
      "waterQualityList",

      "speedList",
      "rehearsalWaterList",
      "pipeList",

      "depthList",
    ]),
  },

  watch: {
    clearMap(newValue, oldValue) {
      if (newValue !== oldValue) {
        if (this.map) {
          this.map.clearMap();
          this.scene?.removeAllLayer();
          this.scene?.removeAllMakers();
        }
      }
    },

    rainList(newValue) {
      if (newValue) {
        console.log("rain list changed");
        this.addMarker({ type: "rain", list: newValue });
      }
    },

    waterList(newValue) {
      if (newValue) {
        console.log("water list changed");
        this.addMarker({ type: "water", list: newValue });
      }
    },

    waterQualityList(newValue) {
      if (newValue) {
        console.log("预警页面的水质数据更新");
        this.addHeatmapLayer(newValue);
      }
    },

    speedList(newValue) {
      if (newValue) {
        console.log("预演页面流速更新");
        this.addLine({ list: newValue });
      }
    },

    rehearsalWaterList(newValue) {
      if (newValue) {
        console.log("预演页面的水位列表更新");
        this.addRehearsalMarker({
          type: "rehearsal-water",
          list: newValue,
        });
      }
    },

    pipeList(newValue) {
      console.log("newvalue", newValue);
    },

    depthList(newValue) {
      console.log("newvalue", newValue);
      this.setDepth(newValue);
    },
  },

  mounted() {
    this.initMap();

    this.scene = new Scene({
      id: "map",
      map: new GaodeMapV2({
        mapInstance: this.map,
      }),
    });

    this.scene.addImage("water-level", require("@/assets/model/marker-bg.png"));

    this.$once("hook:beforeDestroy", () => {
      this.map?.off("click", this.onMapClick);
      this.map?.destroy();
      this.scene?.destroy();
    });
  },

  methods: {
    initMap() {
      const { AMap } = window;
      var map = new AMap.Map("map", {
        showLabel: false,

        center: [118.536766,32.993047],
        zoom: 16,
        zooms: [13, 16.7],
        pitch: 55,
        viewMode: "3D",
        mapStyle: "amap://styles/light",
        // mapStyle: "amap://styles/f3c7464cbaf52050e35d00dc506f4069",
      });
      const layer = new AMap.TileLayer.Satellite();
      map.setLayers([layer]);
      map.on("click", this.onMapClick);
      this.map = map;
    },

    onMapClick(e) {
      console.log(e);
    },

    addMarker({ type = "", list = [], remove = true }) {
      if (!this.map) {
        return;
      }
      const { AMap } = window;

      if (remove) {
        this.removeMarkerClickEvent(this.markers);
        if (Array.isArray(this.markers) && this.markers.length > 0) {
          this.map.remove(this.markers);
        }
      }

      let handledList = list;
      if (type === "rain") {
        // 降雨量
        handledList = list.map((item) => {
          let image;
          if (item.value < 10) {
            image = marker1;
          } else if (item.value < 25) {
            image = marker2;
          } else if (item.value < 50) {
            image = marker3;
          } else if (item.value < 100) {
            image = marker4;
          } else if (item.value < 250) {
            image = marker5;
          } else if (item.value >= 250) {
            image = marker6;
          }
          return {
            ...item,
            icon: new AMap.Icon({
              size: new AMap.Size(40, 40), // 图标尺寸
              image, // Icon的图像
              // imageOffset: new AMap.Pixel(-20, -20), // 图像相对展示区域的偏移量，适于雪碧图等
              imageSize: new AMap.Size(40, 40), // 根据所设置的大小拉伸或压缩图片
            }),
          };
        });
      }

      if (type === "water") {
        handledList = list.map((item) => {
          let image = markerWater;

          return {
            ...item,
            icon: new AMap.Icon({
              size: new AMap.Size(40, 40), // 图标尺寸
              image, // Icon的图像
              // imageOffset: new AMap.Pixel(-20, -20), // 图像相对展示区域的偏移量，适于雪碧图等
              imageSize: new AMap.Size(40, 40), // 根据所设置的大小拉伸或压缩图片
            }),
          };
        });
      }

      if (type === "warning") {
        handledList = list.map((item) => {
          let image = markerWarning;
          return {
            ...item,
            icon: new AMap.Icon({
              size: new AMap.Size(40, 40), // 图标尺寸
              image, // Icon的图像
              // imageOffset: new AMap.Pixel(-20, -20), // 图像相对展示区域的偏移量，适于雪碧图等
              imageSize: new AMap.Size(40, 40), // 根据所设置的大小拉伸或压缩图片
            }),
          };
        });
      }

      if (type === "waterGate") {
        handledList = list.map((item) => {
          let image = markerWaterGateActive;
          return {
            ...item,
            icon: new AMap.Icon({
              size: new AMap.Size(40, 47), // 图标尺寸
              image, // Icon的图像
              // imageOffset: new AMap.Pixel(-20, -20), // 图像相对展示区域的偏移量，适于雪碧图等
              imageSize: new AMap.Size(40, 47), // 根据所设置的大小拉伸或压缩图片
            }),
          };
        });
      }

      const markers = handledList.map((item) => {
        const marker = new AMap.Marker({
          icon: item.icon,
          position: new AMap.LngLat(item.x, item.y),
          // offset: new AMap.Pixel(-35, -20), // 相对于基点的偏移位置
          offset: new AMap.Pixel(-20, -20), // 相对于基点的偏移位置
          extData: {
            id: item.id,
            type,
          },
        });

        marker.on("click", this.onMarkerClick);

        return marker;
      });

      this.markers = markers;
      this.map.add(markers);
    },

    addRehearsalMarker({ list = [] }) {
      // 水位
      const bgLayer = new PointLayer({
        zIndex: 100,
      })
        .source(list, {
          parser: {
            type: "json",
            x: "lng",
            y: "lat",
          },
        })
        .shape("water-level")
        .size(20)
        .color("color")

        .on("click", function (e) {
          console.log(e.feature);
        });

      this.scene?.addLayer(bgLayer);

      const layer = new PointLayer({
        zIndex: 100,
      })
        .source(list, {
          parser: {
            type: "json",
            x: "lng",
            y: "lat",
          },
        })
        .shape("count", "text")
        .size(8)
        .color("#fff");
      // .on("click", function (e) {
      //   console.log(e.feature.id);
      // });

      this.scene?.addLayer(layer);
    },

    addLine({ list = [], showDir = true, roundLine = true }) {
      console.log("this.map", this.map, list);
      if (!this.map) {
        return;
      }

      const { AMap } = window;

      if (list[0] && Array.isArray(list[0].nodes)) {
        list.forEach((item) => {
          if (Array.isArray(item.nodes)) {
            var path = item.nodes.map((element) => {
              return new AMap.LngLat(element.lng, element.lat);
            });

            // 创建折线实例
            var polyline = new AMap.Polyline({
              path: path,
              strokeWeight: 3, // 线条宽度，默认为 1
              strokeColor: item.color, // 线条颜色
              lineJoin: roundLine ? "round" : "miter", // 折线拐点连接处样式
              showDir,
              extData: {
                id: item.us ? item.us.id : "dont find id",
              },
            });

            // 将折线添加至地图实例
            polyline.on("click", (e) => {
              console.log(e.target._opts.extData.id);
            });
            this.map.add(polyline);
          }
        });
      }
    },

    addLabel(arr) {
      console.log("arr", arr);
      console.log("list", this.speedList);

      const result = [];
      for (let i = 0; i < arr.length; i++) {
        const id = arr[i].id;
        for (let j = 0; j < this.speedList.length; j++) {
          const item = this.speedList[j];
          if (Array.isArray(item.nodes) && item.nodes.length > 0) {
            console.log("speed list has item", item);

            if (item.nodes[0].id === id) {
              console.log("find you", item);

              let idx = 0;
              if (item.nodes.length > 1) {
                idx = Math.round(item.nodes.length / 2);
                if (idx > 0) {
                  idx--;
                }
              }

              result.push({
                ...item.nodes[idx],
                count: Number(arr[i].count).toFixed(2),
              });
            }
          }
        }
      }

      console.log("result", result);

      if (!this.map) {
        return;
      }
      const { AMap } = window;

      this.removeMarkerClickEvent(this.markers);
      if (Array.isArray(this.markers) && this.markers.length > 0) {
        this.map.remove(this.markers);
      }

      const markers = result.map((item) => {
        const marker = new AMap.Text({
          position: new AMap.LngLat(item.lng, item.lat),
          offset: new AMap.Pixel(-20, -15), // 相对于基点的偏移位置
          content: `<div style="
            color: #000;
            font-weight: bold;
          "> ${item.count} </div>`, //设置文本标注内容
          extData: {
            id: item.id,
            type: "flow",
          },
        });

        // marker.on("click", this.onMarkerClick);

        // const that = this;

        // marker.on("click", function (e) {
        //   that.flowVisible = true;
        //   console.log("e", e.target._opts.extData.id);
        //   that.flowActiveId = e.target._opts.extData.id;
        // });

        // marker.setLabel({
        //   offset: new AMap.Pixel(20, 20), //设置文本标注偏移量
        //   direction: "right", //设置文本标注方位
        // });

        return marker;
      });

      this.markers = markers;
      this.map.add(markers);
    },

    addHeatmapLayer({ params = {}, list = [] }) {
      this.getPipe();
      this.getrainpipe();

      // 渲染流量和水质的地图标记
      let positionSewage = [];
      let positionRain = [];

      for (let i = 0; i < list.length; i++) {
        const item = list[i];
        const startLng = item.nodes[0].lng;
        const startLat = item.nodes[0].lat;
        const endLng = item.nodes[1].lng;
        const endLat = item.nodes[1].lat;

        // 排口描边

        if (item.type === "sewage") {
          const coordinates = [
            [startLng, startLat],
            [endLng, endLat],
          ];

          positionSewage.push({
            type: "Feature",
            properties: {
              id: item.id,
              type: item.type,
              startLng,
              startLat,
              endLng,
              endLat,
            },
            geometry: {
              type: "LineString",
              coordinates,
            },
          });

          // const vent = ventData.find((element) => element.id === item.id);

          // if (vent) {
          //   const angleValue = getAngle(startLng, startLat, endLng, endLat);

          //   const AMap = window.AMap;

          //   const marker = new AMap.Marker({
          //     zIndex: 500,

          //     position: new AMap.LngLat(endLng, endLat),
          //     icon: markerRed,
          //     angle: angleValue,
          //   });

          //   this.map?.add(marker);
          // }
        }

        if (item.type === "rain") {
          const coordinates = [
            [startLng, startLat],
            [endLng, endLat],
          ];

          positionRain.push({
            type: "Feature",
            properties: {
              id: item.id,
              type: item.type,
              startLng,
              startLat,
              endLng,
              endLat,
            },
            geometry: {
              type: "LineString",
              coordinates,
            },
          });

          const vent = ventData.find((element) => element.id === item.id);

          if (vent) {
            if (vent) {
              const angleValue = getAngle(startLng, startLat, endLng, endLat);

              console.log("angleValue ", angleValue + " id: " + vent.id);

              const AMap = window.AMap;

              var icon = new AMap.Icon({
                size: new AMap.Size(15.25, 7), // 图标尺寸
                image: markerBlue,
                imageSize: new AMap.Size(15.25, 7), // 根据所设置的大小拉伸或压缩图片
              });

              const marker = new AMap.Marker({
                zIndex: 500,
                position: new AMap.LngLat(endLng, endLat),
                angle: angleValue,
                title: vent.id,
                // size: new AMap.Size(30.5, 14),

                // image: markerBlue, // Icon的图像
                // icon: markerBlue,
                icon,
                offset: new AMap.Pixel(-7.5, 0),
                // imageOffset: new AMap.Pixel(-10, 0), // 图像相对展示区域的偏移量，适于雪碧图等
                // imageSize: new AMap.Size(20, 20), // 根据所设置的大小拉伸或压缩图片
              });

              this.map?.add(marker);
            }
          }
        }
      }

      const sourcesSewage = {
        type: "FeatureCollection",
        features: positionSewage,
      };

      const layerSewage = new LineLayer({
        zIndex: 10,
        depth: true,
      })
        .source(sourcesSewage)
        .size(2)
        .shape("line")
        .color("#f00")
        .animate({
          interval: 1, // 间隔
          duration: 2, // 持续时间，延时
          trailLength: 2, // 流线长度
        });

      layerSewage.on("click", (e) => {
        console.log("e", e.feature.properties.id);
        this.visible = true;
        this.detail = e.feature.properties;
        this.params = params;
      });

      this.scene?.addLayer(layerSewage);

      const sourcesRain = {
        type: "FeatureCollection",
        features: positionRain,
      };

      const layerRain = new LineLayer({
        zIndex: 10,
        depth: true,
      })
        .source(sourcesRain)
        .size(2)
        .shape("line")
        .color("#00f")
        .animate({
          interval: 1, // 间隔
          duration: 2, // 持续时间，延时
          trailLength: 2, // 流线长度
        });

      layerRain.on("click", (e) => {
        console.log("e", e.feature.properties.id);
        this.visible = true;
        this.detail = e.feature.properties;
        this.params = params;
      });

      this.scene?.addLayer(layerRain);
    },

    setDepth(list) {
      const layer = new HeatmapLayer({
        zIndex: 100,
      })
        .source(list, {
          parser: {
            type: "json",
            x: "lng",
            y: "lat",
          },
        })
        .shape("heatmap")

        .size("count", [0, 1.0])
        .style({
          rampColors: {
            colors: ["gold", "orange", "red", "red"],
            positions: [0, 0.3, 0.5, 1.0],
          },
        });

      // const layer = new PointLayer({
      //   zIndex: 100,
      // })
      //   .source(list, {
      //     parser: {
      //       type: "json",
      //       x: "lng",
      //       y: "lat",
      //     },
      //   })
      //   .shape("triangle")
      //   .size(10)
      //   .color("color")
      //   .on("click", (e) => {
      //     console.log(e.feature.id);
      //   });

      this.scene?.addLayer(layer);
    },

    ...mapMutations("map", [
      "setActiveRainId",
      "setRainVisible",
      "setActiveWaterId",
      "setWaterVisible",

      "setActiveRehearsalWaterId",
      "setRehearsalWaterVisible",
      "setFlowId",
      "setFlowVisible",
    ]),

    onMarkerClick(e) {
      const { id, type } = e.target._opts.extData;
      if (type === "rain") {
        this.setActiveRainId(id);
        this.setRainVisible(true);
      }

      if (type === "water") {
        this.setActiveWaterId(id);
        this.setWaterVisible(true);
      }

      if (type === "rehearsal-water") {
        this.setActiveRehearsalWaterId(id);
        this.setRehearsalWaterVisible(true);
      }

      if (type === "flow") {
        this.setFlowId(id);
        this.setFlowVisible(true);
      }
    },
    removeMarkerClickEvent(list) {
      if (Array.isArray(list)) {
        list.forEach((item) => {
          item.off("click", this.onMarkerClick);
        });
      }
    },
  },
};
</script>
<style lang="less" scoped>
#map {
  position: fixed;
  top: -50px;
  left: 0;
  right: 0;
  bottom: -20px;
  z-index: 10;
}
</style>